import { useFormContext } from 'react-hook-form'
import numeral from 'numeral'
import { FundingModalFormValues } from 'core/widgets/funding-modal/FundingModal'
import { fundingModalDefaultCustomAmount } from 'core/widgets/funding-modal/constants'
import OtherAmountType from 'core/widgets/funding-modal/edit-amount/OtherAmountType'
import SelectedPayPeriodsAmountType from 'core/widgets/funding-modal/edit-amount/SelectedPayPeriodsAmountType'
import Button from 'core/components/buttons/Button'
import useIndexedPayPeriods from 'core/widgets/funding-modal/useIndexedPayPeriods'
import EditAmountRadio from 'core/widgets/funding-modal/edit-amount/EditAmountRadio'
import { useMemo } from 'react'

const EditAmount = () => {
  const { watch, setValue } = useFormContext<FundingModalFormValues>()
  const [
    amountType,
    enterAmountMode,
    selectedPayPeriodsMode,
    customAmount,
    selectedPayPeriods
  ] = watch([
    'amountType',
    'enterAmountMode',
    'selectPayPeriodsMode',
    'customAmount',
    'selected_pay_periods'
  ])
  const { allPayPeriodsTotal } = useIndexedPayPeriods()

  const disabled = useMemo(() => {
    const customAmountIsDefault =
      customAmount === fundingModalDefaultCustomAmount
    const isInEditMode =
      (enterAmountMode && customAmountIsDefault) || selectedPayPeriodsMode
    const noPayPeriodsSelected =
      amountType === 'selected-pay-periods' && selectedPayPeriods.length === 0
    const customAmountUnchanged =
      amountType === 'other-amount' && customAmountIsDefault

    return isInEditMode || noPayPeriodsSelected || customAmountUnchanged
  }, [
    enterAmountMode,
    selectedPayPeriodsMode,
    amountType,
    selectedPayPeriods,
    customAmount
  ])

  return (
    <div>
      <div className="subtitle-1 font-semibold mb-1">How much?</div>
      <div className="bg-[#F4F5F6] rounded-md px-5 mb-64">
        <div className="flex flex-col">
          <SelectedPayPeriodsAmountType className="py-5 border-b border-b-dark-2" />
          <EditAmountRadio
            label={
              <label
                htmlFor="all-pay-periods"
                className="font-semibold cursor-pointer"
              >
                All pay periods -{' '}
                {numeral(allPayPeriodsTotal).format('$0,0.00')}
              </label>
            }
            value="all-pay-periods"
            className="pt-6 pb-6 border-b border-b-dark-2"
          />
          <OtherAmountType
            className={
              amountType === 'other-amount' && enterAmountMode
                ? 'pt-[0.88rem] pb-[1.4rem]'
                : 'pt-5 pb-7'
            }
          />
        </div>
      </div>
      <Button
        variant="primary"
        className="w-full h-[48px]"
        onClick={() => {
          setValue('view', 'funding-methods')
        }}
        disabled={disabled}
      >
        Done
      </Button>
    </div>
  )
}

export default EditAmount
